import React from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useRecoilState } from "recoil";
import { favourites } from "../../../context/Favourites";

const FavouriteCoin = ({ coin }: { coin: any }) => {
  const [fav, setFav] = useRecoilState<any>(favourites);
  localStorage.setItem("favlist", JSON.stringify(fav));

  const add = (coin: any) => {
    setFav([...fav, coin]);
  };

  const remove = (coin: any) => {
    const newFav = fav.filter((c: any) => c !== coin);
    setFav(newFav);
  };
  const isfav = fav.find((c: any) => c === coin);
  return (
    <div
      className={isfav ? "facIcon" : "facIcon_inactive"}
      onClick={() => (!isfav ? add(coin) : remove(coin))}
    >
      <FontAwesomeIcon icon={faStar} />
    </div>
  );
};

export default FavouriteCoin;
